
import { memo, useCallback, useEffect, useMemo, useState } from "react";
import useValidate from "../../store/hooks/useValidator";
import { useDispatch } from "react-redux";
import { callApiAction } from "../../store/actions/commonAction";
import { closeModal } from "../../store/actions/modalAction";
import { DEVICES_BACK, REPLACEMENT_BOX, SNACK_BAR_VARIETNS, STATUS, USER_ROLES, } from "../../utils/constants";
import { callSnackBar } from "../../store/actions/snackbarAction";
import { getRepairingTicketStatusByIdApi, RepairingUpdateTicketApi } from "../../apis/repairing.api";
import UpdateCreateQueryUi from "./UpdateCreateQueryUi";
import { statusActionFilters, statusCountActionFilters } from "../../store/actions/statusAction";
import { getBoxIdApi, NewBoxIdForDmsUpdateTicketApi } from "../../apis/boxid.api";
import { FetchProblemApi } from "../../apis/problem.api";
import { fetchNotificationAction } from "../../store/actions/notificationAction";
import { getProductAccessoriesApi } from "../../apis/productAccessories.api";
import moment from "moment";
import { getProdutApi, ProductFindByIdApi } from "../../apis/product.api";

const UpdateCreateQueryController = ({ fieldTicket, setTickets, id, statusPass }) => {
  const [selectedDispatch, setSelectedDispatch] = useState();
  const [STATUSWiseData, setSTATUSWiseData] = useState(STATUS.YET_TO_RECEIVED)
  const [replace, SetReplace] = useState();
  const [fields, setFields] = useState({
    id: id,
    err: "",
    createdAt: fieldTicket?.createdAt ? fieldTicket?.createdAt : "",
    ticket_no: fieldTicket?.ticketNo ? fieldTicket?.ticketNo : "",
    product_id: '',
    box_id: "",
    customer_phone: "",
    customer_name: "",
    customer_email: "",
    source_id: "",
    trakingId: "",
    problems: [],
    repairingAmount: [],
    solved_in: "",
    checked: "",
    device_is: "",
    replace_remarks: "",
    customer_address: "",
    new_box_id: "",
    other: "",
    tracking_id: null,
    status: [{
      status_role: null,
      role: null
    }],
    repairing_amount_status: "",
    country:"",
    state:"",
    city:"",
    before_photo: "",
    after_photo: null,
    is_warranty_3_yr:null,
  });

  const [variant1, setVariant] = useState(fields?.solved_in);
  const [loading, setLoading] = useState(false);
  const validate = useValidate();
  const dispatch = useDispatch();
  const modalKey = 'Query';
  const title = "Query";
  const [validation, setvalidation] = useState(false);
  const [productAccessories, setProductAccessories] = useState()
  const [listProblem, setlistProblem] = useState()
  const [boxId, setBoxId] = useState();
  const [listItem, setlistItem] = useState()
  const [threeYrWarranty,setThreeYrWarranty] = useState();

  const validationSchemaForUpdate = useMemo(
    () => [
      {
        required: true,
        value: fields.ticket_no,
        field: "ticket_no",
      },
      {
        required: true,
        value: fields.createdAt,
        field: "createdAt",
      },
      {
        required: true,
        value: fields.product_id,
        field: "product_id",
      },
      {
        // required: true,
        value: fields.customer_email,
        field: "Email",
      },
      {
        required: true,
        value: fields.customer_address,
        field: "customer_address",
      },
      {
        // required: true,
        value: fields.box_id,
        field: "Box Id",
      },

      {
        required: true,
        value: fields.customer_phone,
        field: "Phone",
      },
      {
        required: true,
        value: fields.customer_name,
        field: "Customer Name",
      },
      {
        required: true,
        value: fields.source_id,
        field: "Source",
      },
      {
        required: true,
        value: fields.problems,
        field: "Problems",
      },
      {
        // required: true,
        value: fields.other,
        field: "other",
      },
      {
        required: (statusPass === STATUS.DISPATCH && fields.device_is === "Replace") && true,
        value: fields.new_box_id,
        field: "New Box Id",
      },
      {
        required: (statusPass === STATUS.DISPATCH) && true,
        value: fields.tracking_id,
        field: "tracking id",
      }
    ],
    [fields, statusPass]
  );

  const filters = useMemo(() => ({
    pageNo: 1,
    pageSize: 10,
    search: "",
    searchable: ['customer_name'],
    role: "",
    sort: "createdAt",
    sortDirection: -1,
  }), []);

  const DISPATCH_STATUS = (e) => {
    return fields.repairing_amount_status === "CANCEL_PAYMENT"
      ? [
        {
          status_role: STATUS.COMPLETED,
          role: USER_ROLES.CRM_TEAM,
        },
        {
          status_role: STATUS.COMPLETED,
          role: USER_ROLES.LD,
        },
      ]
      : fields.device_is === "Replace"
        ? [
          {
            status_role: STATUS.REPLACEMENT_COMPLETE,
            role: USER_ROLES.CRM_TEAM,
          },
          {
            status_role: STATUS.REPLACEMENT_COMPLETE,
            role: USER_ROLES.LD,
          },
          {
            status_role: STATUS.REPLACEMENT_COMPLETE,
            role: USER_ROLES.REPAIR_TEAM,
          },
        ]
        : [
          {
            status_role: STATUS.COMPLETED,
            role: USER_ROLES.CRM_TEAM,
          },
          {
            status_role: STATUS.COMPLETED,
            role: USER_ROLES.LD,
          },
          {
            status_role: STATUS.REPAIR_COMPLETED,
            role: USER_ROLES.REPAIR_TEAM,
          },
        ];
  };

  const onSubmit = async (e) => {
    e.preventDefault();
    const validationResponse = validate(validationSchemaForUpdate)
    if (statusPass === STATUS.DISPATCH && fields.device_is === "Replace" && selectedDispatch === DEVICES_BACK.YES && ((replace === REPLACEMENT_BOX.NEW_BOX) || (fields?.product_id?.name !== "HearNU"))) {
      if (validationResponse === true) {
        setLoading(true)
        dispatch(callApiAction(
          async () => await NewBoxIdForDmsUpdateTicketApi({ ...fields, amount: 0, status: STATUSWiseData === STATUS.DISPATCH ? DISPATCH_STATUS() : fields.status }),
          (response) => {
            setLoading(false)
          }, (err) => {
            setFields({ ...fields, err });
            setLoading(false);
          }
        ))
      } else {

        setFields({ ...fields, err: validationResponse })
        setLoading(false)
      }
    }


    if (validationResponse === true) {
      setLoading(true)
      dispatch(callApiAction(
        async () => await RepairingUpdateTicketApi({ ...fields, completed_status: STATUSWiseData === "OTP" ? "Device Received" : "", product_id: fields.product_id?._id ? fields.product_id?._id : fields.product_id, source_id: fields.source_id?._id ? fields.source_id?._id : fields.source_id, status: STATUSWiseData === STATUS.DISPATCH ? DISPATCH_STATUS() : fields.status, country: fields.country?._id ? fields.country?._id : fields.country, state: fields.state?._id ? fields.state?._id : fields.state, city: fields.city?._id ? fields.city?._id : fields.city }),
        (response) => {
          setLoading(false)
          dispatch(callSnackBar("Updated successfully", SNACK_BAR_VARIETNS.suceess));
          dispatch(fetchNotificationAction());
          dispatch(closeModal("UpdateQuery"))
          dispatch(statusActionFilters(filters));
          dispatch(statusCountActionFilters(-1));
        },
        setLoading(false)
      ))
    } else {
      setFields({ ...fields, err: validationResponse })
      setLoading(false)
    }
  };

  const fetchList = (id) => {
     return new Promise((resolve, reject) => {
         dispatch(
           callApiAction(
             async () => await ProductFindByIdApi({ id }),
             (response) => {
               const problems = response?.problems || [];
               setlistProblem(problems);
               setThreeYrWarranty(response?.is_3yr_warranty || null)
               setProductAccessories(response?.product_accessories || [])
               resolve(problems);
               setlistItem(response?.item || [])
             },
             (err) => {
               console.log("Error", err);
               reject(err);
             }
           )
         );
       });
  };

  const fetchById = useCallback((id) => {
    setLoading(true);
    dispatch(
      callApiAction(
        async () => await getRepairingTicketStatusByIdApi({ id }),
        async (response) => {
          setFields(prev => ({ ...prev, ...response }));
          setLoading(false);
          try {
            const data = await fetchList(response?.product_id?._id);
            const todayDate = moment();
            const warrantyDate = moment(response?.warrenty_date);
            const SelectedProblem = data.filter(problem => response.problems.some(p => p.toLowerCase() === problem.name.toLowerCase())) || []
            for (const item of SelectedProblem) {
              const isYear = warrantyDate.isValid() && Math.trunc((new Date(todayDate) - new Date(warrantyDate)) / (1000 * 60 * 60 * 24)) / 365 <= item.warrenty;
              if (!isYear) {
                setvalidation(true);
                break;
              } else {
                setvalidation(false);
              }
            }
          } catch (err) {
            console.error("Error fetching list in fetchById:", err);
          }
        },
        (err) => {
          setFields(prev => ({ ...prev, err }));
          setLoading(false);
        }
      )
    );
  }, [dispatch]);

  useEffect(() => {
    if (id) fetchById(id);
  }, [id, fetchById]);

  const [filtersBoxId, setFiltersBoxId] = useState({
    pageNo: 1,
    pageSize: 10,
    search: "",
    sort: "createdAt",
    sortDirection: -1,
  });

  const FetchBoxId = useCallback(() => {
    dispatch(
      callApiAction(
        async () => await getBoxIdApi({ ...filtersBoxId, searchable: ["boxId", "sold.cphone"] }),
        (response) => {
          if (response?.result?.length < 1) {
          } else {
            setBoxId(response?.result?.map((item) => ({
              boxId: item?.new_box_id ? item?.new_box_id : item?.box_id ? item?.box_id : item.boxId,
              _id: item._id,
              customer_phone: item?.customer_phone ? item?.customer_phone : item.sold?.cphone || "",
              customer_email: item?.customer_email ? item?.customer_email : item.sold?.cemail || "",
              customer_name: item?.customer_name ? item?.customer_name : item.sold?.cname || "",
              customer_address: item?.customer_address ? item?.customer_address : item.sold?.caddress || "",
              band_box_id: item?.band_box_id ? item?.band_box_id : item.convertedProducts?.[0] || "",

              product_id: {
                _id: item?.product_id?._id ?? "",
                name: item?.product_id?.name ?? ""
              },
              source_id: {
                _id: item?.source_id?._id ?? "",
                title: item?.source_id?.title ?? ""
              },
              manufacturer_date: item?.manufacturer_date ?? moment(),
              problems: item?.problems?.length > 0 ? item?.problems : []
            }))
            );
          }
        },
        (err) => {
          console.log("Error", err)
        }
      )
    );
  }, [dispatch, filtersBoxId])

  useEffect(() => {
    FetchBoxId();
  }, [filtersBoxId, FetchBoxId]);

  return (
    <UpdateCreateQueryUi
      threeYrWarranty={threeYrWarranty}
      setThreeYrWarranty={setThreeYrWarranty}
      listProblem={listProblem}
      setProductAccessories={setProductAccessories}
      setlistProblem={setlistProblem}
      modalKey={modalKey}
      title={title}
      loading={loading}
      fields={fields}
      onSubmit={onSubmit}
      setFields={setFields}
      variant1={variant1}
      setVariant={setVariant}
      statusPass={statusPass}
      BoxIDAutoCompleted={boxId}
      setFiltersBoxId={setFiltersBoxId}
      filtersBoxId={filtersBoxId}
      productAccessories={productAccessories}
      selectedDispatch={selectedDispatch}
      setSelectedDispatch={setSelectedDispatch}
      validation={validation}
      setvalidation={setvalidation}
      setSTATUSWiseData={setSTATUSWiseData}
      STATUSWiseData={STATUSWiseData}
      SetReplace={SetReplace}
      replace={replace}
      listItem={listItem}
    />
  );
};
export default memo(UpdateCreateQueryController);
